import { useCallback } from "react";
import {
  ApolloError,
  ApolloQueryResult,
  useApolloClient,
  gql,
} from "@apollo/client";
import {
  GetCourseByIdBackOffice,
  GetCourseByIdBackOfficeVariables,
} from "../__generated__/gql-types/GetCourseByIdBackOffice";

const UseGetCourseByIdBackOffice = () => {
  const client = useApolloClient();

  return useCallback(
    async (variables: GetCourseByIdBackOfficeVariables) => {
      const result: ApolloQueryResult<GetCourseByIdBackOffice> =
        await client.query({
          query: GET_COURSE_BY_ID_BACKOFFICE,
          fetchPolicy: "no-cache",
          variables,
        });

      if (result.error) {
        throw new ApolloError({
          graphQLErrors: result.errors,
        });
      }

      return result.data.getCourseByIdBackOffice;
    },
    [client]
  );
};

export default UseGetCourseByIdBackOffice;

const GET_COURSE_BY_ID_BACKOFFICE = gql`
  query GetCourseByIdBackOffice($courseId: ID!) {
    getCourseByIdBackOffice(courseId: $courseId) {
      id
      lessons {
        title
        id
        order_by
        lesson_type
      }
      lessons_2425
      lessons_2526
      lessons_aux
      sep_book_pages
      sep_book_pages_2017
      sep_book_pages_2425
      sep_book_pages_2526
      sep_book_pages_english
      sep_book_pages_english_2526
      sep_book_pages_english_2526_spark
      sep_book_pages_reading
      sep_book_pages_math_fibonacci
      sep_book_pages_math_descartes
      week
      week_2017
      week_2425
      week_2526
      week_english
      week_english_2526
      week_english_2526_spark
      week_reading
      week_math_fibonacci
      week_math_descartes
      threemester
      threemester_2017
      threemester_2425
      threemester_2526
      threemester_english
      threemester_english_2526
      threemester_english_2526_spark
      threemester_reading
      threemester_math_fibonacci
      threemester_math_descartes
      hide_course_for_students
      subject_id
      grade_id
      month
      nem
      program_2017
      program_2425
      program_2526
      english
      english_2526
      english_2526_spark
      reading
      math_fibonacci
      math_descartes
      axes {
        name
        id
      }
      themes {
        name
        id
      }
      deleted_at
      title
      description
      type
      publish
      subject {
        name
        id
      }
      tags {
        id
        name
      }
      grade {
        name
        id
      }
    }
  }
`;
